/**
 * Cấu hình điểm thưởng cho toàn bộ hệ thống
 * File này tập trung quản lý tất cả các giá trị điểm thưởng/trừ điểm
 * trong ứng dụng để dễ dàng điều chỉnh
 */

// Cấu hình điểm cho AI
export const AI_POINTS = {
  // Chat với AI
  CHAT: {
    BASIC: 2, // Chat thông thường
    LESSON: 2, // Chat về bài học
    COURSE: 3, // Chat về khóa học
    DIAGRAM: 3, // Chat về sơ đồ
    MEDITATION: 4, // Chat về thiền định
    SUTRA: 5, // Chat về kinh điển
  },
  
  // Tạo nội dung bằng AI
  GENERATE: {
    SUMMARY: 5, // Tóm tắt nội dung
    EXPLANATION: 8, // Giải thích chi tiết
    PRACTICE: 10, // Tạo bài tập thực hành
  }
};

// Cấu hình điểm cho hoạt động học tập
export const LEARNING_POINTS = {
  COMPLETE_LESSON: 5, // Hoàn thành bài học
  COMPLETE_COURSE: 20, // Hoàn thành khóa học
  COMPLETE_QUIZ: 3, // Hoàn thành bài kiểm tra
  PERFECT_QUIZ: 5, // Hoàn thành bài kiểm tra với điểm tuyệt đối
};

// Cấu hình điểm cho hoạt động cộng đồng
export const COMMUNITY_POINTS = {
  CREATE_POST: 2, // Tạo bài viết
  COMMENT: 1, // Bình luận
  HELPFUL_ANSWER: 5, // Câu trả lời được đánh dấu là hữu ích
  VOTE: 1, // Bình chọn
};

// Cấu hình điểm cho hoạt động thử thách
export const CHALLENGE_POINTS = {
  DAILY_LOGIN: 1, // Đăng nhập hàng ngày
  DAILY_MEDITATION: 2, // Thiền hàng ngày
  STREAK_BONUS: {
    WEEK: 5, // Chuỗi 7 ngày
    MONTH: 20, // Chuỗi 30 ngày
  },
};

// Cấu hình điểm cho hoạt động đánh giá
export const FEEDBACK_POINTS = {
  RATE_CONTENT: 1, // Đánh giá nội dung
  DETAILED_FEEDBACK: 3, // Phản hồi chi tiết (>50 ký tự)
  REPORT_ISSUE: 2, // Báo cáo lỗi
};

// Hàm helper để lấy số điểm dựa trên loại nội dung
export const getAIChatPoints = (contentType: string | undefined | null): number => {
  if (!contentType) {
    return AI_POINTS.CHAT.BASIC; // Trả về giá trị mặc định nếu contentType không tồn tại
  }
  
  const type = contentType.toUpperCase();
  return AI_POINTS.CHAT[type] || AI_POINTS.CHAT.BASIC;
};

// Export tất cả cấu hình điểm
export default {
  AI: AI_POINTS,
  LEARNING: LEARNING_POINTS,
  COMMUNITY: COMMUNITY_POINTS,
  CHALLENGE: CHALLENGE_POINTS,
  FEEDBACK: FEEDBACK_POINTS,
  getAIChatPoints,
}; 